import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const Img = () => {
  return (
    <StaticImage
      placeholder="blurred"
      src="../../../../images/collar-inteligente-kolyy.png"

      alt="collar inteligente Kolyy"
    />
  );
};

export default Img;
